"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepMapKeysToSnakeCase = exports.deepMapKeysToCamelCase = exports.deepMapKeys = void 0;

var _lodash = _interopRequireDefault(require("lodash.camelcase"));

var _lodash2 = _interopRequireDefault(require("lodash.snakecase"));

var _lodash3 = _interopRequireDefault(require("lodash.mapkeys"));

var _lodash4 = _interopRequireDefault(require("lodash.startswith"));

var _deepObjectMap = _interopRequireDefault(require("./deepObjectMap"));

var deepMapKeys = function deepMapKeys(callback) {
  return (0, _deepObjectMap["default"])(function (object) {
    return (0, _lodash3["default"])(object, function (value, key) {
      return callback(key);
    });
  });
};

exports.deepMapKeys = deepMapKeys;
var deepMapKeysToCamelCase = deepMapKeys(_lodash["default"]);
exports.deepMapKeysToCamelCase = deepMapKeysToCamelCase;
var deepMapKeysToSnakeCase = deepMapKeys(function (key) {
  return (0, _lodash4["default"])(key, '_') ? key : (0, _lodash2["default"])(key);
});
exports.deepMapKeysToSnakeCase = deepMapKeysToSnakeCase;